import React, { useCallback } from "react";
import { DropdownProps } from "@fluentui/react-northstar";

import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";

import { DeviceSelectDropdown } from "./DeviceSelectDropdown";
import { ConnectedDropdownProps } from "./DeviceSelectDropdown.types";

export const ConnectedMicSelectDropdown: React.FC<ConnectedDropdownProps> = ({
  label,
}) => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  const updateSelectedMic: DropdownProps["onChange"] = useCallback(
    (_: any, data: any) => {
      if (data?.value?.["data-itemid"]) {
        deviceTesterDispatch({
          type: DeviceTesterActionType.SET_SELECTED_MICROPHONE,
          microphoneId: data?.value?.["data-itemid"],
        });
      }
    },
    [deviceTesterDispatch]
  );

  return (
    <DeviceSelectDropdown
      label={label}
      deviceList={deviceTesterState.deviceSettings.microphones}
      selectedDevice={deviceTesterState.deviceSettings.selectedMicrophone}
      updateSelectedDevice={updateSelectedMic}
    />
  );
};
